export default "__VITE_ASSET__ehHpsZK3__"